<template>
  <div class="product" :class="size">
    <div class="cover-container">
      <img class="cover" :src="cover" />
      <img class="hot" v-if="hot" src="@/assets/hot_tag@3x.png" />
      <img class="rebate" v-if="rebate" src="@/assets/rebate_tag@3x.png" />
    </div>
    <div class="name" v-if="name">{{ name }}</div>
    <div class="price" v-if="price">€ {{ price }}</div>
  </div>
</template>

<style lang="sass" scoped src="./product-cover.sass"></style>

<script>
export default {
  props: ['name', 'price', 'cover', 'hot', 'rebate', 'url', 'size'],
};
</script>
